import { gql } from 'common/util/gqlRequest';

export const REQUEST_PASSWORD_RESET = gql`
  mutation reset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const LOGIN_WITH_PASSWORD = gql`
  mutation loginWithPassword($email: String!, $password: String!, $rememberMe: Boolean!, $timezoneOffset: Int!) {
    loginWithPassword(email: $email, password: $password, rememberMe: $rememberMe, timezoneOffset: $timezoneOffset)
  }
`;

export const USER_LOGIN_STATE = gql`
  query userLoginState($email: String!) {
    userLoginState(email: $email) {
      ssoLoginEnabled
    }
  }
`;
